import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './DashboardsList.css';

function DashboardsList({ user, onLogout }) {
  const navigate = useNavigate();
  const [dashboards, setDashboards] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    loadDashboards();
  }, []);

  async function loadDashboards() {
    setLoading(true);
    setError('');
    
    try {
      const response = await fetch('/dashboard/api/list.php', {
        credentials: 'include'
      });
      
      if (!response.ok) {
        throw new Error('Errore caricamento dashboard');
      }
      
      const data = await response.json();
      console.log('📥 Dashboards loaded:', data);
      
      if (data.error) {
        setError(data.error);
      } else {
        setDashboards(data.dashboards || []);
      }
    } catch (err) {
      console.error('❌ Error loading dashboards:', err);
      setError('Errore di connessione al server');
    } finally {
      setLoading(false);
    }
  }

  function handleDashboardClick(dashName) {
    console.log('🖱️ Dashboard clicked:', dashName);
    navigate(`/dashboard/${dashName}`);
  }

  return (
    <div className="dashboards-container">
      <nav className="navbar navbar-dark bg-primary px-4 py-3">
        <div className="container-fluid">
          <span className="navbar-brand mb-0 h1">Dashboard Viewer</span>
          <div className="d-flex align-items-center">
            <button className="btn btn-light btn-sm me-2" onClick={() => navigate('/tools')}>
              ← Tools
            </button>
            <span className="text-white me-3">
              <strong>{user?.username || user?.role}</strong>
            </span>
            <button className="btn btn-light btn-sm" onClick={onLogout}>
              Logout
            </button>
          </div>
        </div>
      </nav>

      <div className="content-wrapper">
        {loading && (
          <div className="text-center py-5">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Caricamento...</span>
            </div>
            <p className="mt-3">Caricamento dashboard...</p>
          </div>
        )}

        {error && (
          <div className="container mt-4">
            <div className="alert alert-danger">{error}</div>
          </div>
        )}

        {!loading && !error && dashboards.length === 0 && (
          <div className="container mt-4">
            <div className="alert alert-info">Nessuna dashboard disponibile</div>
          </div>
        )}

        {!loading && !error && dashboards.length > 0 && (
          <div className="container mt-4">
            <h2 className="mb-4">Dashboard Disponibili</h2>
            <div className="dashboard-grid">
              {dashboards.map(dash => (
                <div
                  key={dash.id}
                  className="dashboard-card"
                  onClick={() => handleDashboardClick(dash.name)}
                >
                  <div className="dashboard-icon">📊</div>
                  <h3 className="dashboard-title">{dash.title}</h3>
                  {dash.description && (
                    <p className="dashboard-description">{dash.description}</p>
                  )}
                  <button className="dashboard-button">Apri Dashboard</button>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default DashboardsList;
